'use client'
import CRMPage from "../dashboard/page";

export default function Home() {

  return (
    <CRMPage />
  );
}
